import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { loadRecord } from "MODULES/shared/decorators";
import { RecordPager, ClipboardCopy } from "MODULES/shared/components";
import { shortDate } from "LIB/formatters/date";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import * as actions from "MODULES/SalesOrders/actions";
import { CANCELLED, CODE, CREATED_AT, ID } from "APP_ROOT/constants";
import Panel from "./Panel";
import Body from "./Body";
import Actions from "./Actions";
import Warnings from "./Warnings";
import Total from "./Total";

export function Detail({ salesOrder }) {
  return (
    <div>
      <div className="page-header page-header-bar">
        <h1>
          <div className="with-padding">
            <RecordPager baseUrl="/sales-orders" record={salesOrder} />
            <span className="header-content">{salesOrder.get(CODE)}</span>
            <ClipboardCopy name={salesOrder.get(CODE)} type="SO" />
            <span className="small text-muted">
              Created {shortDate(salesOrder.get(CREATED_AT))}
            </span>
            <Actions
              id={salesOrder.get(ID)}
              salesOrder={salesOrder}
              cancelled={salesOrder.get(CANCELLED)}
            />
            <Total salesOrder={salesOrder} />
            <Warnings salesOrder={salesOrder} />
          </div>
        </h1>
      </div>
      <div className="row">
        <Panel salesOrder={salesOrder.toJS()} />
        <Body salesOrder={salesOrder.toJS()} />
      </div>
    </div>
  );
}

Detail.propTypes = {
  salesOrder: T.instanceOf(Map).isRequired
};

const loader = loadRecord({
  reducer: "salesOrderDetail",
  name: "salesOrder",
  action: id => actions.fetch(id, "no_lines")
});

export default loader(withSalesOrder(Detail));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Detail.jsx